const cart= [
    {
      id: 1,
      title: 'MacBook Air MWTJ2 2020',
      price: 544.99,
      img:
        'https://res.cloudinary.com/de8iseeez/image/upload/v1620306534/MacBook_Air_MWTK2_2020_yqa0gu.jpg',
      color:'gray',
      Shipped:'mxt tech',
      totallNumber:5,
        orderAmount: 1,
    },
    {
      id: 2,
      title: 'MacBook Air MGND3 2020 ',
      price: 499.99,
      img:
        'https://res.cloudinary.com/de8iseeez/image/upload/v1620306533/MacBook_Air_MGND3_2020_pmpme7.jpg',
        color:'gold',
        Shipped:'apple store',
        totallNumber:4,
          orderAmount: 1,
    },
    {
      id: 3,
      title: ' Dell XPS 9300',
      price: 800,
      img:
        'https://res.cloudinary.com/de8iseeez/image/upload/v1620306535/XPS_9300_qamxll.jpg',
        color:'white',
        Shipped:'dell store',
        totallNumber:8,
          orderAmount: 1,
    },
    {
      id: 4,
      title: ' ASUS A515-55G-72HH',
      price: 450,
      img:
        'https://res.cloudinary.com/de8iseeez/image/upload/v1620306533/A515-55G-72HH_qyfbaz.jpg',
        color:'silver',
        Shipped:'Asus world',
        totallNumber:6,
          orderAmount: 1,
    },
    {
      id: 5,
      title: ' huawei MateBook X Pro MACHC-WAE9LP - A',
      price: 699.99,
      img:
        'https://res.cloudinary.com/de8iseeez/image/upload/v1620306535/MateBook_X_Pro_MACHC-WAE9LP_-_A_qorcb5.jpg',
        color:'gray',
        Shipped:'PC World',
        totallNumber:7,
          orderAmount: 1,
    },
  ];
  
const suggestion = [
    {
      id: 6,
      title: ' ASUS 22MK400H 22inches',
      price: 200,
      img:
        'https://res.cloudinary.com/de8iseeez/image/upload/v1620456167/22MK400H_xpqjwx.jpg',
      color:'black',
      Shipped:'Digital lamd',
      totallNumber:6,
        orderAmount: 1,
    },
    {
      id: 7,
      title: 'LG 24MK430H ',
      price: 445,
      img:
        'https://res.cloudinary.com/de8iseeez/image/upload/v1620456167/24MK430H_e61lwp.jpg',
        color:'black',
        Shipped:'LG store',
        totallNumber:2,
          orderAmount: 1,
    },
    {
      id: 8,
      title: 'ASUS',
      price: 800,
      img:
        'https://res.cloudinary.com/de8iseeez/image/upload/v1620456167/ROG_Swift_PG278QE_wd4bym.jpg',
        color:'black',
        Shipped:'Digital land',
        totallNumber:8,
          orderAmount: 1,
    },
    {
      id: 9,
      title: ' beyerdynamic Amiron',
      price: 140,
      img:
        'https://res.cloudinary.com/de8iseeez/image/upload/v1620460666/Amiron_cvutog.jpg',
        color:'black',
        Shipped:'Beyerdynamic',
        totallNumber:2,
          orderAmount: 1,
    },
    {
      id: 10,
      title: ' sandisk microSDHC 16GB',
      price: 15,
      img:
        'https://res.cloudinary.com/de8iseeez/image/upload/v1620456167/microSDHC_qzcotw.jpg',
       
        Shipped:'PC World',
        totallNumber:7,
          orderAmount: 1,
    },
  ];
  export {cart,suggestion}